import React, { useSyncExternalStore } from 'react'
import './singleAccountPreview.scss'

let singleAccount = false
const listeners = new Set<() => void>()

const subscribe = (listener: () => void) => {
    listeners.add(listener)
    return () => {
        listeners.delete(listener)
    }
}

const toggleSingleAccount = () => {
    singleAccount = !singleAccount
    listeners.forEach((listener) => listener())
}

export const useSingleAccountPreview = () =>
    useSyncExternalStore(subscribe, () => process.env.NODE_ENV === 'development' && singleAccount)

export function SingleAccountPreviewToggle() {
    const checked = useSingleAccountPreview()
    if (process.env.NODE_ENV !== 'development') {
        return null
    }
    return (
        <label className="single-account-preview">
            <input type="checkbox" checked={checked} onChange={toggleSingleAccount} />
            Dev: partner with one account
        </label>
    )
}
